module.exports = __webpack_public_path__ + "img/vicon1.1f5bba0a.png";